export default function Privacy() {
  return (
    <div className="pt-32 pb-24 max-w-3xl mx-auto px-6 lg:px-10">
      <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Legal</div>
      <h1 className="font-display text-5xl text-slate-950 leading-none">Privacy Policy</h1>
      <div className="mt-8 space-y-4 text-slate-700 leading-relaxed">
        <p>Your privacy is important to us. We collect only the personal information you voluntarily share via our inquiry forms, phone, or WhatsApp — such as name, contact number, email, and travel preferences.</p>
        <p>This information is used solely to craft and deliver your travel experience. We do not sell, trade, or share your personal information with third parties, except with trusted partners strictly involved in delivering your travel plan.</p>
        <p>You may request deletion of your data at any time by writing to us.</p>
      </div>
    </div>
  );
}
